export default __webpack_public_path__ + "static/media/Bloodsire Helm.8f87606a.jpg";